import React, {useState} from "react";
import {Button, Col, Row} from "antd";
import stores from "../../../store/stores";
import {useFetch} from "../../../hooks/useFetch";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ObjectionsTable from "./ObjectionsTable/ObjectionsTable";
import ObjectionsFilters from "./ObjectionsFilter/ObjectionsFilter";

export const Objections = () => {
    const {t} = useTranslation([]);
    const history = useHistory();
    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [filters, setFilters] = useState({
        companyId: "all",
        subCompanyId: "all",
        lastRespondedBy: "all",
        status: "waitingApprove",
        city: "all"
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.shiftStore.getShiftScoreObjectionList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            companyId: filters.companyId ? filters.companyId : "all",
            subCompanyId: filters.subCompanyId,
            lastRespondedBy: filters.lastRespondedBy,
            status: filters.status,
            city: filters.city
        }),
        dependencies: [filters, currentPage, reloadData]
    });

    return (
        <div>
            <Row align="middle" justify="space-between">
                <Col span={20}>
                    <Row gutter={[8, 8]}>
                        <ObjectionsFilters
                            setCurrentPage={setCurrentPage}
                            setFilters={setFilters}
                            filters={filters}
                        />
                    </Row>
                </Col>
                <Col>
                    <Row justify="end">
                        <Button onClick={() => history.push("/reports/shift-score/list")}>
                            {t("screens.shiftScoreList", {ns: "common"})}
                        </Button>
                    </Row>
                </Col>
            </Row>
            <Row>
                <ObjectionsTable
                    loading={loading}
                    data={data?.rows || []}
                    dataCount={data?.dataCount}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                    reloadData={reloadData}
                />
            </Row>
        </div>
    );
};
